const GHOST_FACTOR = 0.22;
const ghostOpacity = (solidOpacity, amount) => solidOpacity * (1 - amount * (1 - GHOST_FACTOR));
const ghostValues = (solid, amount) => ({
  transparent: amount > 0 || solid.transparent,
  opacity: ghostOpacity(solid.opacity, amount),
  depthWrite: solid.depthWrite,
  castShadow: amount === 0 && solid.castShadow
});
const castsShadow = ({
  overlay,
  transparent
}) => !overlay && !transparent;
export {
  GHOST_FACTOR,
  castsShadow,
  ghostOpacity,
  ghostValues
};
